import React from 'react';
import Form from "./Form"
import SimpleHeader from '../../../components/Headers/SimpleHeader'

export default ({ ...props }) => {
    return (
        <>
            <SimpleHeader
                name="Novo Script de Venda"
                parentName="Scripts de Venda"
                {...props} />
            <Form {...props} />
        </>
    )
}
